<template>
    <div style="height: inherit; align-items: center; display: flex; flex-direction: column; margin:auto;  justify-content: center; ">
        <img style="width: 80%;" src="../assets/vesers-help.png"/>
    </div>
</template>

<script setup>
</script>


<style>
</style>